import React, { FunctionComponent } from "react";
import { HashLoader } from "react-spinners";

interface IProps {
	size?: number;
	color?: string;
}

export const Loading: FunctionComponent<IProps> = props => {
	return (
		<HashLoader
			size={props.size || 25}
			color={props.color || "#000"}
			loading={true}
		/>
	);
};
